export default class MapAction {
    constructor(id, name, iconFilePath, type) {
        this.id = id;
        this.name = name;
        this.iconFilePath = iconFilePath;
        this.type = type;
    }
}